<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { jbrowse, genomeList, syntenyList } from "@/api/dataList";
import router from "./router";
export default {
  name: "home",
  props: {
    //传值
  },
  data() {
    return {};
  },
  components: {
    //引入模块
  },
  watch: {
    // watch擅长处理的场景：一个数据影响多个数据
  },
  computed: {
    // computed擅长处理的场景：一个数据受多个数据影响
  },
  mounted: function () {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
  },
  methods: {
    // 组件的方法
  },
  beforeCreate: function () {
    // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  },
  created: function () {
    // 实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。然而，挂载阶段还没开始，el 属性目前不可见。
  },
  beforeMount: function () {
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  beforeUpdate: function () {
    // 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  },
  updated: function () {
    // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
    // 该钩子在服务器端渲染期间不被调用。
  },
  beforeDestroy: function () {
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
  },
  destroyed: function () {
    // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 该钩子在服务器端渲染期间不被调用。
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  font-size: 16px;
  color: black;
}
</style>
<style>
body {
  margin: 0;
}
.main {
  width: 100%;
  margin: 0 auto;
}
.box {
  /* border: 2px solid #25a3c5; */
  border-radius: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
.mainBox {
  width: 100%;
  margin: auto;
}
.collapse .el-collapse-item__header,
.title {
  height: 35px;
  background: #fafafa;
  color: black;
  /* border-radius: 5px 5px 0 0; */
  border-radius: 10px;
  padding-left: 10px;
  line-height: 35px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 14px; /* no */
}
.form {
  width: 80%;
  margin: 3% auto;
}
.form .el-form-item__label {
  font-weight: bold;
  color: black;
}
.form .el-textarea__inner {
  font-family: sans-serif;
}
.border {
  border: 1px dashed #2c97d0; /* no */
  padding: 20px;
  border-radius: 40px;
}
.canvas {
  margin: 0px auto 10px;
  /* padding: 20px; */
  /* border: 1px solid rgb(196, 194, 194); */
  /* border-radius: 5px; */
}
.el-table,
.el-table thead {
  color: black !important;
  font-size: 14px !important;/* no */
}
fieldset,
.aaa {
  margin-bottom: 15px;
  /* width: 800px; */
  color: #50616d;
  border: #2b6a99 dashed 1px;
  -moz-border-radius: 25px;
  -webkit-border-radius: 25px;
  border-radius: 25px;
  padding: 10px;
}
legend {
  font-weight: bold;
  background: #637e8f;
  color: white;
  border: #b6b6b6 solid 1px;
  margin-left: 25px;
  /* margin-bottom: 20px; */
  font-size: 14px;/* no */
  padding: 5px 15px;
  -moz-border-radius: 15px;
  -webkit-border-radius: 15px;
  border-radius: 15px;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 3px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: rgba(123, 194, 235, 1);
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 3px;
  background: #ededed;
}
.aaaTitle {
  color: #212529;
  display: inline-block;
  margin-bottom: 40px;
  position: relative;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.aaaTitle::after {
  display: block;
  width: 100%;
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 10px;
  content: " ";
  height: 3px;
  background: #4e73bf;
}
</style>
